import { fetchTaskCategories, fetchTaskCategoryFeaturedBlocks } from './effects';
import { $taskCategories, $taskCategoryFeaturedBlocks } from './states';

// Fetch task category featured blocks
$taskCategoryFeaturedBlocks.on(fetchTaskCategoryFeaturedBlocks.doneData, (_, data) => data);

// Fetch task categories
$taskCategories.on(fetchTaskCategories.doneData, (_, data) => data);